<script setup>
import { onMounted, ref } from 'vue'
import { getOfflineTime, setOfflineTime, putOfflineTime } from '@/api/thermostat/devicePoint.js'
import { ElMessage } from 'element-plus'

const num = ref(1)
const formId = ref('')
function getTime() {
    getOfflineTime().then((data) => {
        num.value = data?.thermostat_offline_cycle ?? ''
        formId.value = data?.id
    })
}
async function handleChange() {
    try {
        if (formId.value) {
            await putOfflineTime({
                id: formId.value,
                thermostat_offline_cycle: num.value
            })
            ElMessage.success('设置成功！')
        } else {
            if (!num.value) {
                return ElMessage.error('请输入离线判定时间！')
            }
            await setOfflineTime({
                thermostat_offline_cycle: num.value
            })
            ElMessage.success('设置成功！')
        }
    } catch (error) {
        console.log('🚀 ~ handleChange ~ error:', error)
    }
}

onMounted(() => {
    getTime()
})
</script>

<template>
    <div v-permission="['thermostat:params-config:offline-time']" class="data-container">
        <div class="title">“设备离线”基准判定时间</div>
        <el-form>
            <el-form-item label="离线判定时间（小时）">
                <el-input-number v-model="num" :min="1" :max="72" />
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="handleChange">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<style scoped lang="scss">
.model-container {
    padding: 20px;
}
.title {
    font-size: 16px;
    line-height: 38px;
    font-weight: 600;
    margin-bottom: 20px;
    background-color: rgba(99, 164, 247, 0.1);
    border-left: 2px solid #63a4f7;
    text-indent: 10px;
}
</style>
